import { PlusOutlined } from "@ant-design/icons";
import { generatePath, Link } from "react-router";
import { Id } from "../../../data/types";
import { RoutePaths } from "../../../views/routes";
import Button from "../Button";

interface AddWithButtonProps {
  wishlistId?: Id;
}

export default function PlusWishButton({ wishlistId }: AddWithButtonProps) {
  return (
    <Button link data-testid="add-wish">
      <Link
        to={generatePath(RoutePaths.newWish, { wishlistId: wishlistId || "" })}
        viewTransition
      >
        <PlusOutlined />
      </Link>
    </Button>
  );
}
